import { Loader } from "@googlemaps/js-api-loader"
import MarkerClusterer from '@googlemaps/markerclustererplus';

/*
  == THE MAP ==
  Load and render the map on the page from the Google Maps API

  • https://developers.google.com/maps/documentation/javascript/overview
*/

/* 1TP Dev Key */
const googleAPIKey = "AIzaSyAmFuYqVltrobuOFSgXem4VejYR2pVTmgs";

 /* Live Key */
// const googleAPIKey = "AIzaSyBQA0o5LLYKLy8f7BLBUEYrZfvGkDN0Xf4";

const loader = new Loader({
    // apiKey: ,
    apiKey: googleAPIKey,
    version: "weekly",
    libraries: ["places"]
});

// Map Defaults
const defaultMapCenterLocation = {
  lat: 40.7421803,
  lng: -73.9977326,
  zoom: 15,
  mapId: 'bb4a1a3b1ebbe5db'
};


export { loader, defaultMapCenterLocation, MarkerClusterer };